import { render, staticRenderFns } from "./StatusView.vue?vue&type=template&id=72c5d3d8&scoped=true"
import script from "./StatusView.vue?vue&type=script&lang=js"
export * from "./StatusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5d3d8",
  null
  
)

export default component.exports